import _kk from "../translations/kk.json";
import _en from "../translations/en.json";
import _ru from "../translations/ru.json";
import { nextTick } from 'vue';
import {createI18n} from 'vue-i18n';
import axiosClient from "@/axios";
export const defaultLocale = 'kk';
export const dictionaries = {
  en: _en,
  kk: _kk,
  ru: _ru,
}


export const locales = [
  {
    code: 'ru',
    name: 'Русский',
    dir: 'ltr',
    dictionary: _ru,
  },
  {
    code: 'kk',
    name: 'Қазақша',
    dir: 'ltr',
    dictionary: _kk,
  },
  {
    code: 'en',
    name: 'English',
    dir: 'ltr',
    dictionary: _en,
  },
];
export const supportedLocales = {
  'en': { name: 'English', dir: 'ltr' },
  'ru': { name: 'Русский', dir: 'ltr' },
  'kk': { name: 'Қазақша', dir: 'ltr' },
}
function isI18nValid(locale) {
  const supportedLocales = {
    'en': { name: 'English', dir: 'ltr' },
    'ru': { name: 'Русский', dir: 'ltr' },
    'kk': { name: 'Қазақша', dir: 'ltr' },
  }
  return !!supportedLocales[locale];
}
export const LS_STORAGE_PREFIX = '$-SMART_LOCAL_STORAGE-';
export const LS_LOCALE = LS_STORAGE_PREFIX + 'LOCALE';
export function getCurrentI18n() {
  const locale = localStorage.getItem(LS_LOCALE) ? localStorage.getItem(LS_LOCALE) : defaultLocale;
  return (isI18nValid(locale) ? locale : defaultLocale);
}
export function getCurrentI18nFast() {
  const url = new URL(document.URL);
  return  url.pathname.split('/')[1];
}


let _i18n


function setup(options = { locale: getCurrentI18nFast() }) {
  _i18n = createI18n({

    legacy: false,
    globalInjection: true,
    missingWarn: false,
    warnHtmlInMessage: 'off',
    locale: options.locale,
    fallbackLocale: getCurrentI18nFast(),
    messages: { [getCurrentI18nFast()]: dictionaries[getCurrentI18nFast()] },
  })



  setLocale(options.locale)



  return _i18n

}
// function getCurrentLocale() {
//   const locale = localStorage.getItem(LS_LOCALE) ? localStorage.getItem(LS_LOCALE) : defaultLocale;
//   return this.isLocaleValid(locale) ? locale : defaultLocale;
// }
export function isLocaleValid(locale) {
  return !!locales.find(l => l.code === locale);
}
function setLocale(newLocale) {
  if (!isLocaleValid(newLocale)) return false;
  _i18n.global.locale.value = newLocale
  setDocumentAttributesFor(newLocale)
}
async function loadMessagesFor(locale) {
  if (!isLocaleValid(locale)) return false;
  const messages = await import(
    /* webpackChunkName: "locale-[request]" */ `../translations/${locale}.json`
    )

  _i18n.global.setLocaleMessage(locale, messages.default)

  return nextTick()
}

function setDocumentAttributesFor(locale) {
  const htmlElement = document.querySelector('html')

  localStorage.setItem(LS_LOCALE, locale);
  axiosClient.defaults.headers['X-Localization'] = locale;
  htmlElement.setAttribute('lang', locale)
  htmlElement.setAttribute('dir', supportedLocales[locale].dir)
}
export default {
  get vueI18n() {
    return _i18n
  },
  setup,
  setLocale,
  loadMessagesFor,
  getCurrentI18n,
  isLocaleValid,
  locales
}
